import { Component, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-message-kanban-box',
  templateUrl: './message-box-kanban.component.html',
  styleUrls: ['./message-box-kanban.component.css']
})
export class MessageBoxKanbanDialog {

  message: any[];
  html: string;

  constructor(public dialogRef: MdDialogRef<MessageBoxKanbanDialog>,
    @Inject(MD_DIALOG_DATA) public data: any) {
      if (data.html) {
        this.html = data.html;
      } else {
        try {
          this.message = [];
          const jsonError = JSON.parse(data.message);
          for (const key in jsonError) {
            this.message.push ({message : jsonError[key]});
          }
        } catch (e) {
          this.message.push ({message: data.message});
        }
      }
    }
}


// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/message-box-kanban/message-box-kanban.component.ts